import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  // 删除试题
  function deleteQuestion(question) {
    vue.$emit("deleteExamQuestion", question);
  }

  const Deal = ({ props: { vo } }) => {
    const question = vo.row;
    const dealConf = [
      [
        "icon-delete",
        "删除",
        () => {
          deleteQuestion(question);
        }
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    { label: "main", type: "selection" },
    {
      label: "试题名称",
      prop: "questionTitle",
      showOverflowTooltip: true
    },
    {
      label: "试题类型",
      prop: "examQuestionTypeName",
      width: '100'
    },
    {
      label: "试题主题",
      prop: "questionTheme",
      showOverflowTooltip: true
    }
  ];
  if (!args.props.fromDetail) {
    AccountTableConfig.push({
      label: "操作",
      width: '100',
      render: (vo) => <Deal vo={vo} />,
    });
  }

  return (
    <List
      {...args}
      empty-text="尚未添加任何试题，点击右上角【试题管理】可进行试题添加"
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
